export const pagesEnum = {
  home: '/',
  about: '/about',
  projects: '#projects',
  blog: '/blog',
  flights:'/flights'
} as const

export const navMode = {
  withinPage: "withinPage",
  multiPage: 'multiPage',
} as const

export const attributeLanguages = {
  HTML: "HTML,#e34c26",
  CSS: "CSS, rebeccapurple",
  JAVA: "JAVA,#5382a1",
  JAVASCRIPT: "JAVASCRIPT,#F0DB4F",
  PYTHON: "PYTHON, #FFD43B",
  CPP: "CPP, #659AD2",
  SYSTEM_VERILOG: "SYSTEM_VERILOG, Orange",
  react: "React, #61DAFB",
  PostgreSQL: "PostgreSQL, #00aeff",
  OpenGL: "OpenGL, #6f00ff",
  NextJS: "NextJS, #000000",
  "Adobe Premiere Pro": "Adobe Premiere Pro, #330D3E",
  Luck: "Luck, Black",
  Docker: "Docker, #1D63ED",
  NAS: "Network Attached Storage, #26D4AC",
  ArcGIS: "ArcGIS, #2632d4ff"
} as const